import React, { useState } from "react";
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
  Typography,
  Upload,
} from "antd";
import { SettingOutlined } from "@ant-design/icons";

import { locations } from "../../../../helpers/constants";

const { Title } = Typography;

const locationOptions = [
  {
    value: locations.federacijaBiH,
    label: locations.federacijaBiH,
  },
  {
    value: locations.republikaSrpska,
    label: locations.republikaSrpska,
  },
  {
    value: locations.brckoDistrikt,
    label: locations.brckoDistrikt,
  },
];

const brandOptions = [
  "ALFA-ROMEO",
  "FORD",
  "HYUNDAI",
  "AUDI",
  "JEEP",
  "MMAZDA",
  "BMW",
  "MERCEDES-BENZ",
  "item01",
  "item02",
  "item03",
  "item04",
  "item05",
  "item06",
];

const OpstiPodaci = ({ supplierState, goForward, brands }) => {
  console.log(brands);
  const [form] = Form.useForm();

  const onChange = (checkedValues) => {
    console.log(checkedValues);
  };

  const normFile = (e) => {
    console.log(e);
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  return (
    <>
      <Row className="pl-6 py-8">
        <Col span={12}>
          <Form.Item
            initialValue={supplierState && supplierState.companyName}
            labelAlign="right"
            label="Naziv kompanije"
            name="kompanija"
            rules={[
              {
                required: true,
                message: "Unesite naziv kompanije!",
              },
            ]}
          >
            <Input placeholder="Unesite naziv kompanije" />
          </Form.Item>

          <Form.Item
            initialValue={supplierState && supplierState.IdNumber}
            labelAlign="right"
            label="ID broj"
            name="id"
            rules={[
              {
                required: true,
                message: "Unesite ID broj!",
              },
            ]}
          >
            <InputNumber
              className="w-full"
              type="number"
              placeholder="Unesite ID broj"
            />
          </Form.Item>

          <Form.Item
            initialValue={supplierState && supplierState.VATNumber}
            labelAlign="right"
            label="PDV broj"
            name="pdv"
          >
            <InputNumber
              className="w-full"
              type="number"
              placeholder="Unesite PDV broj"
            />
          </Form.Item>

          <Form.Item
            initialValue={supplierState && supplierState.address}
            labelAlign="right"
            label="Adresa"
            name="adresa"
            rules={[
              {
                required: true,
                message: "Unesite adresu kompanije!",
              },
            ]}
          >
            <Input placeholder="Unesite adresu kompanije" />
          </Form.Item>

          <Form.Item
            initialValue={supplierState && supplierState.authorizedPerson}
            labelAlign="right"
            label="Ovlaštena osoba"
            name="ovlašten"
            rules={[
              {
                required: true,
                message: "Unesite ime i prezime ovlaštene osobe!",
              },
            ]}
          >
            <Input placeholder="Unesite ime i prezime ovlaštene osobe" />
          </Form.Item>

          <Form.Item
            initialValue={supplierState && supplierState.phoneNumber}
            labelAlign="right"
            label="Broj telefona"
            name="telefon"
            rules={[
              {
                required: true,
                message: "Unesite broj telefona u formatu +387 XX YYY ZZZ!",
              },
            ]}
          >
            <Input placeholder="Unesite broj telefona u formatu +387 XX YYY ZZZ" />
          </Form.Item>

          <Form.Item
            initialValue={supplierState && supplierState.location}
            labelAlign="right"
            label="Lokacija"
            name="lokacija"
            rules={[
              {
                required: true,
                message: "Odaberite lokaciju!",
              },
            ]}
          >
            <Select
              placeholder="Odaberite lokaciju zbog obračuna poreza"
              options={locationOptions}
            />
          </Form.Item>

          {/* <Form.Item
            name="logo"
            label="Logo Dobavljača"
            valuePropName="fileList"
            getValueFromEvent={normFile}
          >
            <Upload accept=".png,.jpg" maxCount={1} listType="picture">
              <Button icon={<SettingOutlined />}>Klikni da dodaš</Button>
            </Upload>
          </Form.Item> */}

          <Form.Item>
            <Button
              htmlType="button"
              onClick={goForward}
              className="ml-2 mt-3 text-sm text-white bg-light-blue font-medium w-[132px] rounded-sm border-light-blue shadow-sm"
            >
              IDUĆI KORAK
            </Button>
          </Form.Item>
        </Col>
        <Col span={10} className="pl-10">
          <Title className="text-dark-blue text-[16px] font-normal">
            BRENDOVI DOBAVLJAČA
          </Title>
          <Space className="bg-brand-bg border border-dashed border-brand-border rounded-md pl-8 pt-6">
            <Form.Item
              initialValue={
                supplierState && supplierState?.brands.map((brand) => brand.id)
              }
              name="brand"
              rules={[
                {
                  required: true,
                  message: "Odaberite brand!",
                },
              ]}
            >
              <Checkbox.Group
                className="gap-2"
                options={brands?.map((brand) => ({
                  value: brand.id,
                  label: brand.name,
                }))}
              />
            </Form.Item>
          </Space>
        </Col>
      </Row>
    </>
  );
};

export default OpstiPodaci;
